<template>
    <div class="pb-5">
      <nav-bar/>
      <!-- <sidebar-toggle-button/> -->
      <div class="filter-button-group">
        <div class="d-flex justify-content-center align-items-center">
        <toggle-button-group
        :buttons="tabOptions" 
        :activeButton="selectedOrderFilter" 
        :handleClick="handleFilterButtonClick" 
      />
        <div v-if="isAdmin" class="toggle-button-group">
          <button
              :key="'verifyButton'"
              :class="{ active: selectedOrderFilter === 'verify' }"
              @click="handleToggle('verify')"
          >
              {{ this.$t('OrderCurrent.sidebar.toVerify') }}
          </button>
        </div>
        <div v-if="isOdooBillingEnabled" class="toggle-button-group ml-3">
          <button :class="{ active: viewMode === 'table' }" @click="setViewMode('table')">
            {{ $t('ToBillBoard.table_view') }}
          </button>
          <button :class="{ active: viewMode === 'board' }" @click="setViewMode('board')">
            {{ $t('ToBillBoard.board_view') }}
          </button>
        </div>
          </div>
      </div>

      <to-bill-group-board
        v-if="isOdooBillingEnabled && viewMode === 'board'"
        :orders="delivered"
      />

      <table-listing
        v-else
        :arrOfOrders="delivered"
        :defaultFieldsObj="fieldsObj"
        :activeTab="'toBill'"
        :isDateRoute="isDateRoute"
        :disableDefaultSort="false"
        :isBillingBtn="true"
        :fromToBillPage="true"
      />
  
      <loading-render v-if="isLoading" />

      <status-change-modal
        v-if="isStatusEdit"
        ref="shortDispatchModal"
        :arrOfOrder="selectedFull"
        :isOpen="isStatusEdit"
        :priceOrderLink="priceOrderLink"
        @closeModal="isStatusEdit = false; clear()"
        @clearSelected="clearSelected"
      />
    </div>
  </template>
  
  <script>
  import { gmapApi } from 'vue2-google-maps'
  import Modal from '../module/interface-components/Modal.vue'
  import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
  import regularInput from '../module/basic-components/regularInput.vue'
  import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import Search from '../module/special-components/Other-components/Search.vue'
  import StatusChangeModal from '../module/special-components/Modal-templates/StatusChange-modal.vue'
  import {db} from '../../firebase'
  // import _ from 'lodash'
  import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
  import regularInputNumber from '../module/basic-components/regularInputNumber.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import ToggleSwitch from '../module/special-components/Other-components/ToggleSwitch.vue'
  import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
  import CustomDatePick from '../module/special-components/Custom-packages/Custom-DatePick.vue'
  import CustomJsonExcel from '../module/special-components/Custom-packages/Custom-JsonExcel.vue'

  import TableListing from '../module/special-components/Table-component/Table-Listing.vue'
  import { dryBoxMixin } from '../../utils/dryBoxLabels'
  import ToBillGroupBoard from '../module/special-components/Other-components/ToBillGroupBoard.vue'
  import { isRegularOrder } from '@/inventory/inventorySelectors'

  export default {
    name: 'orderDelivered',
    mixins: [dryBoxMixin],
    components: {
      Modal,
      regularInput,
      regularCheckbox,
      regularTextarea,
      regularInputNumber,
      regularDatalistDriver,
      Search,
      SidebarToggleButton,
      regularSelect,
      TableElement,
      LoadingRender,
      ToggleSwitch,
      hoverToolTip,
      ToggleButtonGroup,
      StatusChangeModal,
      CustomDatePick,
      CustomJsonExcel,
      TableListing,
      ToBillGroupBoard
    },
  
    data () {
      return {
        deliverySave: false,
        VIN: '',
        MAKE: '',
        MODEL: '',
        YEAR: '',
        SIZE: '',
        selected: [],
        vehicles: [],
        isConfirmModalOpen: false,
        user: {
          name: '',
          address: '',
          city: '',
          zipCode: '',
          province: '',
          phone: '',
          nir: '',
          cigle: '',
          logo: ''
        },
        pricingAndDelay: [],
        priceOrderLink: [], // This is to create a price/order link list for dispatches
        pickupSave: false,
        inProgress: '',
        filterResults: [],
        spreadDate: '',
        selectedOrder: {},
        searchHistory: [],
        selectedFull: [],
        selectedFull2: [],
        searchType: '',
        searchText: '',
        historyTypeTag: '',
        sizeTooltipText: '',
        isOdooBill: false,
        priceTooltipText: '',
        sizeTooltipColor: '',
        priceTooltipColor: '',
        isEditOrderModal: false,
        billing: false,
        isStatusEdit: false,
        vinPrinting: false,
        quickEdit: false,
        hideTitleonPrint: false,
        backup: {
          sageIDDelivery: ''
        },
        datalist: {
          pickup: '',
          pickupUid: '',
          delivery: '',
          deliveryUid: '',
          billing: '',
          billingUid: ''
        },
        fields: {
          numRef: '',
          vin: '',
          source: '',
          creationDate: '',
          receiverAddress: '',
          transmitterAddress: '',
          payerAddress: ''
        },
        suggestedPrice: 0,
        modal: {
          openPrice: false
        },
        order: {
          comment: '',
          latitude: 0.001,
          longitude: 0.001,
          make: '',
          model: '',
          datePromis: '',
          dateExpected: '',
          nbDispatch: 0,
          numRef: '',
          payer: '',
          payerAddress: '',
          payerCity: '',
          payerContact: '',
          payerFax: '',
          payerName: '',
          payerPhone: '',
          payerEmail: '',
          payerPostcode: '',
          payerCountry: '',
          payerProvince: '',
          receiver: '',
          receiverAddress: '',
          receiverCity: '',
          receiverContact: '',
          receiverFax: '',
          receiverName: '',
          receiverPhone: '',
          receiverEmail: '',
          receiverPostcode: '',
          receiverCountry: '',
          receiverProvince: '',
          status: 'Drop',
          source: '',
          transmitter: '',
          transmitterAddress: '',
          transmitterCity: '',
          transmitterContact: '',
          transmitterFax: '',
          transmitterName: '',
          transmitterPhone: '',
          transmitterEmail: '',
          transmitterPostcode: '',
          transmitterCountry: '',
          transmitterProvince: '',
          transpCigle: '',
          transpName: '',
          vin: '',
          year: '',
          regularPrice: 0,
          price: 0,
          discount: 0,
          surplus: 0
        },
        fieldsObj: [
        {
            text: `<i class="fa fa-solid fa-clipboard" />`,
            mobileText: this.$t('OrderCurrent.survey'),
            type: 'survey',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.order'),
            type: '.key',
            value: ''
        },
        {
          text: this.$t('OrderCurrent.reference'),
          type: 'numRef',
          value: ''
        },
        {
            text: this.fieldLabel('vin'),
            type: 'vin',
            value: ''
        },
        {
            text: this.fieldLabel('model'),
            type: 'model',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.pickup'),
            type: 'transmitterName',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.delivery'),
            type: 'receiverName',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.billing'),
            type: 'payerName',
            value: ''
        },
        {
            text: this.$t('OrderDelivered.expected_price'),
            type: 'regularPrice',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.modal.odoo_status'),
            type: 'odooStatus',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.driver'),
            type: 'driverName',
            value: ''
        },
        {
            text: this.$t('logs.table_header.action'),
            type: 'action',
            value: ''
        }
        ],
        buttonList: {
          heavy: {
            id: 4,
            label: this.$t('OrderCurrent.modal.heavy'),
            value: 'Heavy',
            selected: false,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          },
          medium: {
            id: 3,
            label: this.$t('OrderCurrent.modal.medium'),
            value: 'Medium',
            selected: false,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          },
          light: {
            id: 2,
            label: this.$t('OrderCurrent.modal.light'),
            value: 'Light',
            selected: false,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          },
          noSize: {
            id: 1, // If you change this id, also change it in @function setVehicleSize
            label: this.$t('OrderCurrent.modal.nosize'),
            value: 'No Size',
            selected: true,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          }
        },
        selectedOrderFilter: 'tobill',
        viewMode: localStorage.getItem('toBillViewMode') || 'board',
        orderFilterOptions: [
          { label: `${this.$t('OrderCurrent.sidebar.pending')}`, value: 'pending', route: '/OrderPending' },
          { label: this.$t('OrderCurrent.sidebar.current'), value: 'in_progress', route: '/OrderCurrent' },
          { label: this.$t('OrderCurrent.sidebar.delivered'), value: 'delivered', route: '/OrderDelivered' },
          { label: this.$t('OrderCurrent.sidebar.toBill'), value: 'tobill', route: '/ToBill' },
          { label: this.$t('OrderCurrent.sidebar.waiting'), value: 'waiting', route: '/Waiting' },
          { label: this.$t('OrderCurrent.sidebar.date'), value: 'date', route: '/OrderCurrent?newDate=true' }
        ],
        isLoading: true
      }
    },
  
    created () {
        this.isLoading = true
        this.$store.state.isSidebarOpen = false
        this.isScreenSmall = window.innerWidth < 800

        // Use store deliveries instead of binding
        if (!this.$store.state.deliveriesLoaded) {
          this.$store.dispatch('subscribeToDeliveries')
        }

        // Check if already loaded
        if (this.$store.state.deliveriesLoaded) {
          this.isLoading = false
        } else {
          // Watch for deliveries to be loaded
          const unwatch = this.$watch(
            () => this.$store.state.deliveriesLoaded,
            (loaded) => {
              if (loaded) {
                this.isLoading = false
                unwatch()
              }
            }
          )
        }
    },
  
    methods: {
      handleFilterButtonClick (buttonName) {
        this.activeButton = buttonName
        const selectedOption = this.tabOptions.find(option => option.value === buttonName)
        if (selectedOption && selectedOption.route) {
          this.$router.push(selectedOption.route)
        }
      },
      handleToggle (route) {
        this.$router.push(`/${route}`)
      },
      setViewMode (mode) {
        this.viewMode = mode
        localStorage.setItem('toBillViewMode', mode)
      },
  
      getStringVehicleSize (size = '1') {
        let text = ''
        const keys = Object.keys(this.buttonList)
  
        text = keys.find(key => this.buttonList[key].id.toString() === size.toString())
        text = this.buttonList[text].label
  
        return text
      },
      clearSelected () {
        this.selected = []
      },
      clearfeedbackMessage () {
        this.feedbackMessage = ''
      },
      clear: function () {
        for (let attr in this.order) {
          this.order[attr] = ''
        }
        this.clearfeedbackMessage()
        this.order.regularPrice = 0
        this.order.price = 0
        this.order.discount = 0
        this.order.surplus = 0
        this.order.status = 'Processing'
        this.order.latitude = 0.001
        this.order.longitude = 0.001
        this.order.nbDispatch = 0
        for (let attr in this.datalist) {
          this.datalist[attr] = ''
        }
        this.vehicles = []
        this.VIN = ''
        this.MAKE = ''
        this.MODEL = ''
        this.YEAR = ''
        this.SIZE = null // Car size check
        this.badVin = false // Valid vin check
      },

      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },
  
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
        this.$store.commit('setUserInfo', snapshot.val() || false)
        this.user = snapshot.val()
      })
    },
  
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
  
    computed: {
      delivered () {
        return this.$store.state.deliveries.filter(order => isRegularOrder(order) && order.isBilling === true)
      },
      google: gmapApi,
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      isOdooBillingEnabled () {
        return !!(this.$store.state.userInfo.featureFlags && this.$store.state.userInfo.featureFlags.odooBilling)
      },
      isDateRoute () {
        return this.$route.query.newDate
      },
  
      // TODO: Check for invalid postal codes that contain special characters Ex: VIN - 2HGFC3B31GH427642
      returnPostcodePath () {
        if (this.selectedOrder.transmitterPostcode === '' || this.selectedOrder.receiverPostcode === '') console.log('Empty postcodes', this.selectedOrder.transmitterPostcode, this.selectedOrder.receiverPostcode)
        const transmitterPostcode = this.selectedOrder.transmitterPostcode || 'NoTransmitter'
        const receiverPostcode = this.selectedOrder.receiverPostcode || 'NoReceiver'
        let path = ''
  
        path = transmitterPostcode.toLowerCase() + receiverPostcode.toLowerCase()
        path = path.split(' ').join('')
  
        return path
      },
      companyUID () {
        return this.$store.state.authorization.company
      },

      uid () {
        return this.$store.state.user.uid
      },
      currentCount () {
        return this.$store.state.deliveries.filter(order =>
          isRegularOrder(order) &&
          order.status !== 'Drop' &&
          order.status !== 'to cancel' &&
          order.status !== 'Attente' &&
          order.status !== 'to finish' &&
          !order.isBilling
        ).length
      },
      deliveredCount () {
        return this.$store.state.deliveries.filter(order =>
          isRegularOrder(order) && order.status === 'Drop' && !order.isBilling
        ).length
      },
      toBillCount () {
        return this.$store.state.deliveries.filter(order =>
          isRegularOrder(order) && order.isBilling === true
        ).length
      },
      waitingCount () {
        return this.$store.state.deliveries.filter(order =>
          isRegularOrder(order) && order.status === 'Attente' && !order.isBilling
        ).length
      },
      tabOptions () {
        return [
          { label: this.$t('OrderCurrent.sidebar.pending'), value: 'pending', route: '/OrderPending' },
          { label: this.$t('OrderCurrent.sidebar.current'), value: 'in_progress', route: '/OrderCurrent', count: this.currentCount },
          { label: this.$t('OrderCurrent.sidebar.delivered'), value: 'delivered', route: '/OrderDelivered', count: this.deliveredCount },
          { label: this.$t('OrderCurrent.sidebar.toBill'), value: 'tobill', route: '/ToBill', count: this.toBillCount },
          { label: this.$t('OrderCurrent.sidebar.waiting'), value: 'waiting', route: '/Waiting', count: this.waitingCount },
          { label: this.$t('OrderCurrent.sidebar.date'), value: 'date', route: '/OrderCurrent?newDate=true' }
        ]
      }
    }
  }
  </script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #suggested_price {
    background-color: #dfdfdf;
    border-radius: 3px;
    }
    .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
    }
    #action{
    display: flex;
    justify-content: end;
    min-width: 110px;
    }
    .kne-tab.active{
    color: #f7941e !important;
    }
    .kne-tab:hover{
    color: #f7941e !important;
    }
    .view{
    padding-left: 10.5rem;
    }

    .flexContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    }
    .mobileFlexContainer {
    flex-direction: column;
    }
    .addressContainer {
    width: 50%;
    }

    .carInfoContainer {
    width: 25%;
    }

    .miscContainer {
    display:flex;
    flex-direction: column;
    align-content: flex-end;
    width: 25%;
    }

    label {
    margin-left: 1rem;
    }
    .toggle-button-group button {
        border: 1px solid transparent;
        padding: 6px 16px;
        cursor: pointer;
        outline: none;
        background:white;
        border-left:1px solid rgba(201, 192, 192, .4);
        border-right: 1px solid rgba(201, 192, 192, .4);
    }

    .toggle-button-group button.active {
        background-color: #f7941e;
        color: white;
        border:1px solid transparent;
    }
    .toggleSwitch {
    display: flex;
    flex-direction: row;
    justify-content: center;
    }
    .tooltip-wrapper {
      position: relative;
      display: inline-block;
    }

    .tooltip-text {
      visibility: hidden;
      background-color: black;
      color: #fff;
      text-align: center;
      border-radius: 4px;
      padding: 4px 8px;
      position: absolute;
      z-index: 1;
      top: -35px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      font-size: 12px;
    }

    .tooltip-wrapper:hover .tooltip-text {
      visibility: visible;
    }

</style>
